import { useContext, useEffect } from 'react';
import { MapContext } from '../../contexts/MapContext';
import { setMultiLayerVisibility, setRoads } from '../../utils/map';
import { baseLayerTypes } from '../../hooks/useBaseLayer';
import { NAIP_LAYER_ID } from './NaipLayer';
import { AZURE_LAYER_ID } from './AzureLayer';
import {
  BACKGROUND_COLORS,
  CONTOUR_LAYERS,
  NO_SATELLITE_BACKGROUND,
  SATELLITE_LAYER_ID,
  STREET_LINES_LAYER_ID,
  WATER_LAYERS,
} from '../../constants/map';

const BaseMap = ({ map }) => {
  const {
    baseMapState: { baseLayer, contour, roads, dark },
  } = useContext(MapContext);
  const setBaseMap = (layerType) => {
    const baseMapLayersHidden = {
      [NO_SATELLITE_BACKGROUND]: false,
      [NAIP_LAYER_ID]: false,
      [SATELLITE_LAYER_ID]: false,
      [AZURE_LAYER_ID]: false,
      [STREET_LINES_LAYER_ID]: false,
      ...WATER_LAYERS.reduce(
        (acc, layerId) => ({
          ...acc,
          [layerId]: false,
        }),
        {},
      ),
    };
    const toLayerList = (layerMap) =>
      Object.entries(layerMap).map(([layerId, isVisible]) => ({
        layerId,
        isVisible,
      }));
    switch (layerType) {
      case baseLayerTypes.NAIP_SATELLITE: {
        setMultiLayerVisibility(
          map,
          toLayerList({
            ...baseMapLayersHidden,
            [NAIP_LAYER_ID]: true,
            // show satellite layer even if NAIP is enabled
            [SATELLITE_LAYER_ID]: true,
            ...WATER_LAYERS.reduce(
              (acc, layerId) => ({
                ...acc,
                [layerId]: true,
              }),
              {},
            ),
          }),
        );
        break;
      }
      case baseLayerTypes.AZURE_SATELLITE: {
        setMultiLayerVisibility(
          map,
          toLayerList({
            ...baseMapLayersHidden,
            [AZURE_LAYER_ID]: true,
          }),
        );
        break;
      }
      case baseLayerTypes.NO_SATELLITE: {
        setMultiLayerVisibility(
          map,
          toLayerList({
            ...baseMapLayersHidden,
            [NO_SATELLITE_BACKGROUND]: true,
            ...WATER_LAYERS.reduce(
              (acc, layerId) => ({
                ...acc,
                [layerId]: true,
              }),
              {},
            ),
          }),
        );
        break;
      }
      default: {
        setMultiLayerVisibility(
          map,
          toLayerList({
            ...baseMapLayersHidden,
            [SATELLITE_LAYER_ID]: true,
          }),
        );
      }
    }
  };

  useEffect(() => {
    setBaseMap(baseLayer);
  }, [baseLayer]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setMultiLayerVisibility(
      map,
      CONTOUR_LAYERS.map((layerId) => ({
        layerId,
        isVisible: contour,
      })),
    );
  }, [contour]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setRoads(map, roads, baseLayer === baseLayerTypes.NO_SATELLITE);
  }, [baseLayer, roads]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    map.setPaintProperty(
      NO_SATELLITE_BACKGROUND,
      'background-color',
      dark ? BACKGROUND_COLORS.dark : BACKGROUND_COLORS.light,
    );
  }, [dark]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default BaseMap;
